





































import { computed, defineComponent } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'
import { formatDate, convertStringToDate } from '~/common/utils/dates'
import { useProductStore } from '~/store/product'

export default defineComponent({
  setup() {
    const productStore = useProductStore()
    const { currentProduct } = storeToRefs(productStore)

    const productLink = computed(() => {
      return currentProduct.value.data.attributes.jsonUrls?.product
    })

    const pricesLink = computed(() => {
      return currentProduct.value.data.attributes.jsonUrls?.prices
    })

    const referencesLink = computed(() => {
      return currentProduct.value.data.attributes.jsonUrls?.references
    })

    return {
      product: currentProduct,
      formatDate,
      convertStringToDate,
      productLink,
      pricesLink,
      referencesLink,
    }
  },
})
